import React from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import { Link } from "react-router-dom";
import LoginButton from "../../login/login-button";

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20
  },
  nested: {
    paddingLeft: theme.spacing.unit * 2
  },
  textItem : {
    color : 'black'
  }
});

function createStaticPageJSON(name, displayName) {
  return {
    name,
    displayName
  };
}

const STATIC_PAGES = [
  createStaticPageJSON("PROJECT", "El Proyecto"),
  createStaticPageJSON("CREDITS", "Creditos"),
  createStaticPageJSON("FAQ", "Preguntas Frecuentes"),
  createStaticPageJSON("REFERENCES", "Citando"),
  createStaticPageJSON("PUBLICATIONS", "Publicaciones"),
  createStaticPageJSON("METHODOLOGY", "Metodología"),
];

class MenuAppBar extends React.Component {
  state = {
    open: false,
    openPages: false
  };

  toggleDrawer = () =>
    this.setState(state => ({
      open: !state.open
    }));

  handleClickPages = () => {
    this.setState(state => ({ openPages: !state.openPages }));
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AppBar position="static">
          <Toolbar>
            <IconButton
              className={classes.menuButton}
              color="inherit"
              aria-label="Menu"
              onClick={this.toggleDrawer}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              color="inherit"
              className={classes.grow}
            >
              Atlas de la salud de Colombia
            </Typography>
            <LoginButton />
          </Toolbar>
        </AppBar>
        <Drawer open={this.state.open} onClose={this.toggleDrawer}>
          <List>
            <ListItem
              component={Link}
              //to="/admin/index/"
              to="/home"
              onClick={this.toggleDrawer}
            >
              <ListItemText primary="Home" className={classes.textItem} />
            </ListItem>
            <ListItem
              component={Link}
              to="/admin/indicators"
              onClick={this.toggleDrawer}
            >
              <ListItemText primary="Indicadores" className={classes.textItem}/>
            </ListItem>
            <ListItem
              component={Link}
              to="/admin/indicator-types"
              onClick={this.toggleDrawer}
            >
              <ListItemText primary="Tipos indicador" className={classes.textItem}/>
            </ListItem>
            <ListItem
              component={Link}
              to="/admin/resources-tags"
              onClick={this.toggleDrawer}
            >
              <ListItemText primary="Tags recursos" className={classes.textItem}/>
            </ListItem>
            <ListItem
              component={Link}
              to="/admin/layers"
              onClick={this.toggleDrawer}
            >
              <ListItemText primary="Cartografía" className={classes.textItem}/>
            </ListItem>
            <ListItem
              component={Link}
              to="/admin/files"
              onClick={this.toggleDrawer}
            >
              <ListItemText primary="Archivos" className={classes.textItem}/>
            </ListItem>
            <ListItem
              component={Link}
              to="/admin/researchers"
              onClick={this.toggleDrawer}
            >
              <ListItemText primary="Investigadores" className={classes.textItem}/>
            </ListItem>
            <ListItem
              component={Link}
              to="/admin/stats"
              onClick={this.toggleDrawer}
            >
              <ListItemText primary="Estadísticas" className={classes.textItem}/>
            </ListItem>
            <ListItem
              component={Link}
              to="/admin/users"
              onClick={this.toggleDrawer}
            >
              <ListItemText primary="Usuarios" className={classes.textItem}/>
            </ListItem>
            <ListItem button onClick={this.handleClickPages}>
              <ListItemText primary="Páginas estáticas" className={classes.textItem}/>
              {this.state.openPages ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={this.state.openPages} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {STATIC_PAGES.map(page => {
                  return (
                    <ListItem
                      key={page.name}
                      component={Link}
                      to={`/admin/static/${page.name}`}
                      onClick={this.toggleDrawer}
                      className={classes.nested}
                    >
                      <ListItemText inset primary={page.displayName} className={classes.textItem}/>
                    </ListItem>
                  );
                })}
              </List>
            </Collapse>
          </List>
        </Drawer>
      </div>
    );
  }
}

MenuAppBar.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(MenuAppBar);



// WEBPACK FOOTER //
// ./src/components/admin/menu-bar/index.js